import { ConcreteEncodable } from "./ConcreteEncodable";

import { FwdRollOrderDataImplEncoder } from "../../encoder/FwdRollOrderDataImplEncoder";

import * as CubiqTS from "../../index";
import { FwdRollOrderData } from "../FwdRollOrderData";

export class FwdRollOrderDataImpl extends ConcreteEncodable implements FwdRollOrderData {
  public static enType: string = "com.bcdfx.model.fwdroll.FwdRollOrderDataImpl";

  /*FID=1*/
  public fixingDts: CubiqTS.moment.Moment | null = null;
  /*FID=4*/
  public fixingCd: string;
  /*FID=5*/
  public lastSaveDts: CubiqTS.moment.Moment | null = null;
  /*FID=6*/
  public lastSaveUserCode: string;
  /*FID=7*/
  public lastSaveUserId: CubiqTS.Long | null = null;
  /*FID=8*/
  public portfolioId: string;
  /*FID=9*/
  public clientCd: string;
  /*FID=13*/
  public orders: Array<CubiqTS.OrderData> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FwdRollOrderDataImplEncoder.Instance;
    this.setEncodableType(FwdRollOrderDataImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "FwdRollOrderDataImpl[" +
      "fixingDts=" +
      this.fixingDts +
      "fixingCd=" +
      this.fixingCd +
      "lastSaveDts=" +
      this.lastSaveDts +
      "lastSaveUserCode=" +
      this.lastSaveUserCode +
      "lastSaveUserId=" +
      this.lastSaveUserId +
      "portfolioId=" +
      this.portfolioId +
      "clientCd=" +
      this.clientCd +
      "orders=" +
      this.orders +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
